import React, { createContext, useState, useContext, useEffect, ReactNode } from 'react';

interface User {
  token: string;
  type: 'client' | 'barber' | 'admin';
  id: string;
}

interface AuthContextType {
  user: User | null;
  login: (token: string, userType: 'client' | 'barber' | 'admin', userId: string) => void;
  logout: () => void;
  loading: boolean;
}

const AuthContext = createContext<AuthContextType | null>(null);

interface AuthProviderProps {
  children: ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const userType = localStorage.getItem('userType') as 'client' | 'barber' | 'admin';
    const userId = localStorage.getItem('userId');
    if (token && userType && userId) {
      setUser({ token, type: userType, id: userId });
    }
    setLoading(false);
  }, []);

  const login = (token: string, userType: 'client' | 'barber' | 'admin', userId: string) => {
    localStorage.setItem('token', token);
    localStorage.setItem('userType', userType);
    localStorage.setItem('userId', userId);
    setUser({ token, type: userType, id: userId });
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('userType');
    localStorage.removeItem('userId');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}; 